/**
 *  The identity of a card/slot
 *  @export
 *  @param {number} cardRank The rank of the card (0-13)
 *  @param {string} cardSuit The suit of the card "hearts", "spades", "diamonds", "clubs", or "empty"
 */
export class CardID {
    private cardRank: number;
    private cardSuit: string;
    constructor(num: number, suit: string) {
        this.cardRank = num;
        this.cardSuit = suit;
    }

    /**
     *  Gets the suit of the card
     *  @returns {string} "hearts", "spades", "diamonds", "clubs", or "empty"
     */
    getSuit(): string {
        return this.cardSuit;
    }

    /**
     *  Gets the rank of the card
     *  @returns {number} 2 - 13(K)
     */
    getRank(): number {
        return this.cardRank;
    }

    /**
     *  Sets the identity of the card to the new identity passed or empty.
     *  @returns {string} img name of card
     */
    toName(): string {
        return `${this.cardRank}_of_${this.cardSuit}`;
    }

    equals(card: CardID): boolean {
        return (
            this.getRank() === card.getRank() &&
            this.getSuit() === card.getSuit()
        );
    }
}

let lastDeck: CardID[] = [];

const defaultDeck: CardID[] = [
    new CardID(13, "hearts"),
    new CardID(12, "hearts"),
    new CardID(11, "hearts"),
    new CardID(10, "hearts"),
    new CardID(9, "hearts"),
    new CardID(8, "hearts"),
    new CardID(7, "hearts"),
    new CardID(6, "hearts"),
    new CardID(5, "hearts"),
    new CardID(4, "hearts"),
    new CardID(3, "hearts"),
    new CardID(2, "hearts"),
    //    new CardID(1, "hearts"),
    new CardID(0, "empty"),

    new CardID(13, "spades"),
    new CardID(12, "spades"),
    new CardID(11, "spades"),
    new CardID(10, "spades"),
    new CardID(9, "spades"),
    new CardID(8, "spades"),
    new CardID(7, "spades"),
    new CardID(6, "spades"),
    new CardID(5, "spades"),
    new CardID(4, "spades"),
    new CardID(3, "spades"),
    new CardID(2, "spades"),
    //    new CardID(1, "spades"),
    new CardID(0, "empty"),

    new CardID(13, "diamonds"),
    new CardID(12, "diamonds"),
    new CardID(11, "diamonds"),
    new CardID(10, "diamonds"),
    new CardID(9, "diamonds"),
    new CardID(8, "diamonds"),
    new CardID(7, "diamonds"),
    new CardID(6, "diamonds"),
    new CardID(5, "diamonds"),
    new CardID(4, "diamonds"),
    new CardID(3, "diamonds"),
    new CardID(2, "diamonds"),
    //    new CardID(1, "diamonds"),
    new CardID(0, "empty"),

    new CardID(13, "clubs"),
    new CardID(12, "clubs"),
    new CardID(11, "clubs"),
    new CardID(10, "clubs"),
    new CardID(9, "clubs"),
    new CardID(8, "clubs"),
    new CardID(7, "clubs"),
    new CardID(6, "clubs"),
    new CardID(5, "clubs"),
    new CardID(4, "clubs"),
    new CardID(3, "clubs"),
    new CardID(2, "clubs"),
    //    new CardID(1, "clubs"),
    new CardID(0, "empty"),
];

/**
 *  Randomly populates cards from defaultDeck into a new array of CardID.
 *  @returns {CardID[]} A new dealt deck
 */
export function dealRandom(): CardID[] {
    const defaultCopy: CardID[] = [...defaultDeck];
    const deck: CardID[] = [];
    // for (let i = 0; i < 52; i++) {
    for (let i = 51; i >= 0; i--) {
        deck.push(
            // defaultDeck[i],
            defaultCopy.splice(
                Math.floor(Math.random() * (i - 0 + 1)) + 0,
                1,
            )[0],
        );
    }

    return deck;
}

export function dealEasy(replay: boolean): CardID[] {
    if (replay) return lastDeck;
    const defaultCopy: CardID[] = [...defaultDeck]; //this
    const deck: CardID[] = [];
    // for (let i = 0; i < 50; i++) {
    //this - I switched 50 to 52
    for (let i = 51; i >= 0; i--) {
        deck.push(
            // defaultDeck[i], //this
            defaultCopy.splice(
                Math.floor(Math.random() * (i - 0 + 1)) + 0,
                1,
            )[0],
        );
    }
    lastDeck = deck;
    return deck;
}
